// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_to-object.js
// module id = 93
// module chunks = 168707334958949